import { Vertragsgrund } from '@ps20/bff-models';
import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { AngebotsId } from './angebotsId';

export interface VorschlagsdatenRequestPayload {
  angebotsIds: AngebotsId[];
}

export function getGeschaeftsart(vertragsoptionen: Vertragsoptionen): Vertragsgrund {
  if (isNeugeschaeft(vertragsoptionen) && !vertragsoptionen?.beibehalten) {
    return Vertragsgrund.NEUANLAGE;
  }
  if (vertragsoptionen?.beibehalten) {
    return Vertragsgrund.BEIBEHALTUNG;
  }
  return Vertragsgrund.ERSATZGESCHAEFT;
}

export function getAuslandsRisikoZuschlag(
  isDiplomatengeschaeft: boolean,
  nachlass: number,
): number {
  return isDiplomatengeschaeft ? nachlass : null;
}

export const isNeugeschaeft = (vertragsoptionen: Vertragsoptionen): boolean =>
  !vertragsoptionen?.vorvertragsNummern || vertragsoptionen?.vorvertragsNummern.length === 0;
